<template>
  <div class="ladder-page">
    <div class="ladder-toolbar">
      <div class="d-flex align-items-center flex-wrap ladder-filters">
        <div class="d-flex align-items-center flex-nowrap">
          <b-form-select class="ml-2" v-model="show_top_n" :options="topNOptions" size="sm"></b-form-select>
          <b-form-select class="ml-2" v-model="plate_max_count" :options="plateMaxOptions" size="sm"></b-form-select>
          <b-button class="ml-2" size="sm" variant="outline-primary" @click="refreshPage" aria-label="刷新">
            <b-icon icon="arrow-clockwise"></b-icon>
          </b-button>
        </div>
        <b-form-datepicker size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1" today-button close-button locale="zh"></b-form-datepicker>
      </div>
    </div>

    <div v-if="loading" class="text-center text-muted py-4">加载中...</div>
    <div v-else class="ladder-grid">
      <div v-for="section in ladderSections" :key="'ban-' + section.ban" class="ladder-row">
        <div class="ladder-col-left">
          <div class="ladder-ban">{{ section.ban }}板</div>
          <div class="ladder-count">{{ section.items.length }}只</div>
        </div>
        <div class="ladder-col-right">
          <div v-for="item in section.items" :key="section.ban + '-' + item.stock_code" class="ladder-item" :class="{ 'ladder-item-fail': isFailed(section.ban, item) }">
            <div class="ladder-item-main">
              <span v-if="isFailed(section.ban, item)" class="ladder-time" :style="getPctStyle(item.next_close_pct)"><span class="ladder-fail-icon">✕</span>{{ formatPct(item.next_close_pct) }}</span>
              <span v-else class="ladder-time">{{ item.up_limit_time || '--:--' }}<span v-if="getUpLimitTag(item.up_limit_type)" class="ladder-up-type">{{ getUpLimitTag(item.up_limit_type) }}</span></span>
              <span class="ladder-name">{{ item.stock_name }}</span>
            </div>
            <div class="ladder-item-sub">
              <span v-for="plate in filterPlates(item.plates)" :key="item.stock_code + '-' + plate" class="ladder-plate">{{ plate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="ladderSections.length===0" class="text-center text-muted py-4">暂无数据</div>
    </div>
    <div class="ladder-footer-tip">内容来自AI自动整理,不做任何投资建议.</div>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request'

export default {
  data() {
    const now = new Date()
    const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
    return {
      date1: today,
      all_trading_days: [],
      last_trade_day: '',
      prev_trade_day: '',
      show_top_n: 12,
      plate_max_count: 3,
      topNOptions: [
        { value: 'all', text: '板块top: 全部' },
        { value: 5, text: '板块top: 5个' },
        { value: 8, text: '板块top: 8个' },
        { value: 10, text: '板块top: 10个' },
        { value: 12, text: '板块top: 12个' },
        { value: 15, text: '板块top: 15个' },
        { value: 20, text: '板块top: 20个' }
      ],
      plateMaxOptions: [
        { value: 2, text: '板块数: 2' },
        { value: 3, text: '板块数: 3' },
        { value: 4, text: '板块数: 4' }
      ],
      plates: [],
      plate_stocks: {},
      failed_stocks_by_ban: {},
      bans: [],
      loading: false,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768
    },
    ladderSections() {
      return this.buildSections(1)
    }
  },
  watch: {
    show_top_n() {
      this.updateInfo(this.date1)
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    request_zzquant({url:'/open/trade/days'}).then(res => {
      const days = res && res.data && res.data.data ? res.data.data : []
      if (days && days.length) {
        this.all_trading_days = days
        this.last_trade_day = days[days.length - 1]
        this.prev_trade_day = days[days.length - 2] || ''
        this.date1 = this.last_trade_day || this.date1
      }
      this.updateInfo(this.date1)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    refreshPage() {
      this.updateInfo(this.date1)
    },
    onDatePicked(ctx) {
      this.date1 = ctx.selectedYMD
      this.updateInfo(this.date1)
    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay()
      const time = date.getTime()
      const now = new Date().getTime()
      if (weekday === 0 || weekday === 6) return true
      if (time >= now) return true
      return false
    },
    timeToMinutes(t) {
      if (!t) return 9999
      const parts = String(t).split(':')
      if (parts.length < 2) return 9999
      const h = parseInt(parts[0], 10)
      const m = parseInt(parts[1], 10)
      if (isNaN(h) || isNaN(m)) return 9999
      return h * 60 + m
    },
    buildSections(minBan) {
      const sections = []
      const plates = Array.isArray(this.plates) ? this.plates : []
      const plateStocks = this.plate_stocks || {}
      const bans = (this.bans || []).filter(b => Number(b) >= minBan)
      const failedMap = this.failed_stocks_by_ban || {}
      bans.forEach(ban => {
        const map = {}
        plates.forEach(plate => {
          const list = plateStocks[plate.code] || []
          list.forEach(stock => {
            if (Number(stock.up_limit_keep_times) === Number(ban)) {
              const code = stock.stock_code || ''
              if (!code) return
              if (!map[code]) {
                map[code] = {
                  stock_name: stock.stock_name || stock.stock_code,
                  stock_code: code,
                  up_limit_time: stock.up_limit_time || '',
                  up_limit_desc: stock.up_limit_desc || '',
                  up_limit_type: stock.up_limit_type,
                  up_limit_keep_times: stock.up_limit_keep_times,
                  next_close_pct: stock.next_close_pct,
                  plates: []
                }
              }
              const pName = plate.name || ''
              if (pName && !map[code].plates.includes(pName)) {
                map[code].plates.push(pName)
              }
            }
          })
        })
        const failedList = failedMap[String(ban)] || []
        failedList.forEach(stock => {
          const code = stock.stock_code || ''
          if (!code) return
          if (!map[code]) {
            map[code] = {
              stock_name: stock.stock_name || stock.stock_code,
              stock_code: code,
              up_limit_time: stock.up_limit_time || '',
              up_limit_desc: stock.up_limit_desc || '',
              next_close_pct: stock.next_close_pct,
              failed_from_prev: true,
              plates: Array.isArray(stock.plates) ? stock.plates : []
            }
          }
        })
        const items = Object.values(map)
        if (!items.length) return
        items.sort((a, b) => {
          const af = this.isFailed(ban, a) ? 1 : 0
          const bf = this.isFailed(ban, b) ? 1 : 0
          if (af !== bf) return af - bf
          return this.timeToMinutes(a.up_limit_time) - this.timeToMinutes(b.up_limit_time)
        })
        sections.push({ ban, items })
      })
      return sections
    },
    getPrevTradingDay(date1) {
      const days = this.all_trading_days || []
      const idx = days.indexOf(date1)
      if (idx > 0) return days[idx - 1]
      return ''
    },
    buildFailedMap(data) {
      const result = {}
      const plates = data && data.plate ? data.plate : []
      const plateStocks = data && data.plate_stocks ? data.plate_stocks : {}
      plates.forEach(item => {
        const plateName = item[0]
        const plateCode = item[1]
        const list = plateStocks[plateCode] || []
        list.forEach(stock => {
          const ban = Number(stock.up_limit_keep_times)
          if (ban < 3) return
          const val = Number(stock.next_close_pct)
          if (isNaN(val) || val >= 9.5) return
          const code = stock.stock_code || ''
          if (!code) return
          if (!result[String(ban)]) result[String(ban)] = []
          const exists = result[String(ban)].some(s => s.stock_code === code)
          if (exists) return
          result[String(ban)].push({
            stock_name: stock.stock_name || stock.stock_code,
            stock_code: code,
            up_limit_time: stock.up_limit_time || '',
            up_limit_desc: stock.up_limit_desc || '',
            up_limit_type: stock.up_limit_type,
            up_limit_keep_times: stock.up_limit_keep_times,
            next_close_pct: stock.next_close_pct,
            plates: [plateName]
          })
        })
      })
      return result
    },
    updateInfo(date1) {
      this.loading = true
      const prevDate = this.getPrevTradingDay(date1)
      this.prev_trade_day = prevDate
      const limitParam = this.show_top_n === 'all' ? '' : '&limit=' + this.show_top_n
      const currentReq = request_zzquant({
        url: 'v3/open/review/uplimit/hot?date1=' + date1 + limitParam
      })
      const prevReq = prevDate
        ? request_zzquant({
          url: 'v3/open/review/uplimit/hot?date1=' + prevDate + limitParam
        })
        : Promise.resolve(null)
      Promise.all([currentReq, prevReq]).then(resArr => {
        const res = resArr[0]
        const prevRes = resArr[1]
        const data = res && res.data && res.data.data ? res.data.data : {}
        const plates = data.plate || []
        const plateArr = []
        plates.forEach((item, idx) => {
          if (this.show_top_n !== 'all' && idx >= Number(this.show_top_n)) return
          plateArr.push({ name: item[0], code: item[1], score: item[2] })
        })
        this.plates = plateArr
        this.plate_stocks = data.plate_stocks || {}
        const maxCount = Number(data.max_count) || 0
        const banArr = []
        for (let i = maxCount; i >= 1; i--) banArr.push(i)
        this.bans = banArr
        const prevData = prevRes && prevRes.data && prevRes.data.data ? prevRes.data.data : null
        this.failed_stocks_by_ban = prevData ? this.buildFailedMap(prevData) : {}
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    isFailed(ban, item) {
      if (Number(ban) < 3) return false
      if (item && item.failed_from_prev) return true
      const pct = item ? item.next_close_pct : null
      if (pct === undefined || pct === null || pct === '') return false
      const val = Number(pct)
      if (isNaN(val)) return false
      return val < 9.5
    },
    formatPct(val) {
      if (val === undefined || val === null || val === '') return '--'
      const num = Number(val)
      if (isNaN(num)) return '--'
      const fixed = Math.abs(num) >= 10 ? num.toFixed(1) : num.toFixed(2)
      return fixed + '%'
    },
    getGradientColor(start_color, end_color, percent) {
      start_color = start_color.replace(/^\s*#|\s*$/g, '')
      end_color = end_color.replace(/^\s*#|\s*$/g, '')
      if (start_color.length == 3) {
        start_color = start_color.replace(/(.)/g, '$1$1')
      }
      if (end_color.length == 3) {
        end_color = end_color.replace(/(.)/g, '$1$1')
      }
      function parse(rgb, i) {
        return parseInt(rgb.substr(i, 2), 16)
      }
      let start_r = parse(start_color, 0),
        start_g = parse(start_color, 2),
        start_b = parse(start_color, 4)
      let end_r = parse(end_color, 0),
        end_g = parse(end_color, 2),
        end_b = parse(end_color, 4)
      let r = end_r - start_r
      let g = end_g - start_g
      let b = end_b - start_b
      r = ((r * percent) + start_r)
      g = ((g * percent) + start_g)
      b = ((b * percent) + start_b)
      function hex(x) {
        let h = x.toString(16).split('.')[0].toUpperCase()
        return (h.length == 1) ? '0' + h : h
      }
      return '#' + hex(r) + hex(g) + hex(b)
    },
    getPercentColorFont(pt) {
      const isDark = document.body.classList.contains('theme-dark')
      if (pt === undefined || pt === null || pt === '') {
        return isDark ? '#9ca3af' : '#6c757d'
      }
      pt = Number(pt)
      if (isNaN(pt) || pt === 0) {
        return isDark ? '#e5e5e5' : '#111111'
      }
      if (pt > 0) {
        pt = +pt / 10
        const start = isDark ? '#f87171' : '#FF99CC'
        return this.getGradientColor(start, '#FB1023', pt)
      }
      if (pt < -10) {
        pt = -10
      }
      pt = -pt / 10
      const start = isDark ? '#4ade80' : '#66FF55'
      return this.getGradientColor(start, '#278B22', pt)
    },
    getPctStyle(val) {
      return { color: this.getPercentColorFont(val) }
    },
    getUpLimitTag(val) {
      const v = val === undefined || val === null ? '' : String(val)
      if (v === '一') return '一字'
      if (v === 'T') return 'T字'
      return ''
    },
    getKeepTag(val) {
      const num = Number(val)
      if (isNaN(num) || num <= 1) return ''
      return '炸' + num
    },
    filterPlates(plates) {
      const list = Array.isArray(plates) ? plates : []
      const blocked = new Set([
        '年报增长',
        '国有企业',
        '深圳',
        '广东省',
        '华为概念',
        '金融概念',
        '三季报增长',
        '江苏省',
        '北京市',
        '浙江',
        '一带一路',
        '西部大开发'
      ])
      const limit = Number(this.plate_max_count) || 3
      return list.filter(p => p && !blocked.has(p)).slice(0, limit)
    }
  }
}
</script>

<style scoped>
.ladder-page{
  min-height: 100vh;
  display:flex;
  flex-direction:column;
}
.ladder-toolbar{
  display:flex;
  align-items:center;
  justify-content:space-between;
  flex-wrap:wrap;
  gap:8px;
  margin-bottom:4px;
  margin-top:-4px;
}
.ladder-filters .form-control{
  height:28px;
  font-size:12px;
}
.ladder-filters .btn{
  height:24px;
  padding:0 6px;
  min-width:36px;
}
.ladder-grid{
  display:flex;
  flex-direction:column;
  gap:4px;
  max-height: calc(100vh - 130px);
  overflow-y:auto;
  padding-bottom:6px;
}
.ladder-footer-tip{
  color:#9ca3af;
  font-size:12px;
  text-align:center;
  padding:6px 0 10px;
}
.ladder-row{
  display:grid;
  grid-template-columns: 56px 1fr;
  gap:8px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1px 5px 1px 10px;
}
.ladder-col-left{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  border-right:1px dashed var(--border-color);
  padding-right:2px;
}
.ladder-ban{
  font-weight:700;
  color:#c02b2b;
  background: #fff1f1;
  padding:2px 8px;
  border-radius:10px;
  font-size:12px;
}
.ladder-count{
  color:#666;
  font-size:11px;
  margin-top:4px;
}
.ladder-col-right{
  display:flex;
  flex-wrap:wrap;
  gap:2px;
  align-content:flex-start;
}
.ladder-item{
  padding:1px 2px;
  background:#fff2f2;
  border-radius:6px;
  border:1px solid #f1b5b5;
  flex: 0 0 calc(16.666% - 2px);
  min-width: 50px;
}
.ladder-item-fail{
  background: var(--bg-muted);
  border-color: transparent;
}
.ladder-time,
.ladder-name{
  color:#b42323;
}
.ladder-plate{
  background:#ffe3e3;
  color:#b42323;
}
.ladder-item-fail .ladder-time,
.ladder-item-fail .ladder-name{
  color:#666;
}
.ladder-item-fail .ladder-plate{
  background:#f6f7fb;
  color:#777;
}
.ladder-fail-icon{
  margin-right:2px;
  font-weight:700;
}
.theme-dark .ladder-item-fail{
  background:#1f2937;
  border-color:#374151;
}
.theme-dark .ladder-item-fail .ladder-time,
.theme-dark .ladder-item-fail .ladder-name{
  color:#e5e7eb;
}
.theme-dark .ladder-item-fail .ladder-plate{
  background:#111827;
  color:#cbd5f5;
}
.ladder-item-main{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:1px;
  font-size:10px;
  font-weight:700;
}
.ladder-time{
  font-size:9px;
}
.ladder-up-type{
  margin-left:2px;
  font-size:8px;
}
.ladder-name{
  color:#000000;
  font-size:10px;
  font-weight:700;
}
.ladder-item-sub{
  margin-top:0;
  display:flex;
  align-items:center;
  gap:1px;
  font-size:8px;
  color:#777;
  flex-wrap:wrap;
}
.ladder-plate{
  background:#f6f7fb;
  border-radius:10px;
  padding:0 2px;
}
.ladder-desc{
  background:#fff2d9;
  color:#a95c00;
  border-radius:10px;
  padding:0 6px;
}
@media (max-width: 768px){
  .ladder-toolbar{
    flex-direction:column;
    align-items:flex-start;
  }
  .ladder-filters{
    width:100%;
  }
  .ladder-filters .form-control{
    min-width: 140px;
  }
  .ladder-grid{
    max-height: calc(100vh - 150px);
  }
  .ladder-row{
    grid-template-columns: 52px 1fr;
  }
  .ladder-col-left{
    padding-right:2px;
  }
  .ladder-col-right{
    gap:2px;
  }
  .ladder-item{
    flex: 0 0 calc(20% - 2px);
    min-width: 50px;
  }
}
</style>
